<template>
<navbar v-model="showNavbar" class="abc">
    <div class="navbar-wrapper">
        <!-- <a class="navbar-brand" href="#">Home Design Furniture </a> -->
        <router-link to="/"><img src="../../../../public/logo.png" alt="logo" height="50px" /></router-link>

    </div>

    <template slot="navbar-menu">

        <b-navbar-nav>
            <b-nav-item to="/admin/dashboard">Dashboard</b-nav-item>

            <drop-down tag="li" position="right" direction="none" class="nav-item btn-rotate dropdown">
                <a slot="title" slot-scope="{ isOpen }" class="nav-link dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" :aria-expanded="isOpen">
                    Master </a>
                <router-link to="/admin/dashboard/role"><a class="dropdown-item">Role</a></router-link>
                <router-link to="/admin/dashboard/user"><a class="dropdown-item">User Management</a></router-link>
                <router-link to="/admin/dashboard/customer"><a class="dropdown-item">Customer</a></router-link>

            </drop-down>

            <drop-down tag="li" position="right" direction="none" class="nav-item btn-rotate dropdown">
                <a slot="title" slot-scope="{ isOpen }" class="nav-link dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" :aria-expanded="isOpen">
                    Products </a>
                <router-link to="/admin/dashboard/category"><a class="dropdown-item">Category</a></router-link>
                <router-link to="/admin/dashboard/subcategory"><a class="dropdown-item">Sub Category</a></router-link>
                <router-link to="/admin/dashboard/product"><a class="dropdown-item">Product</a></router-link>

            </drop-down>

            <drop-down tag="li" position="right" direction="none" class="nav-item btn-rotate dropdown">
                <a slot="title" slot-scope="{ isOpen }" class="nav-link dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" :aria-expanded="isOpen">
                    Marketing </a>
                <router-link to="/admin/dashboard/promotion"><a class="dropdown-item">Promotion</a></router-link>
                <router-link to="/admin/dashboard/referral"><a class="dropdown-item">Referral</a></router-link>
                <router-link to="/admin/dashboard/lead"><a class="dropdown-item">Lead</a></router-link>
                <router-link to="/admin/dashboard/wishlist"><a class="dropdown-item">Wishlist</a></router-link>
                <router-link to="/admin/dashboard/cart"><a class="dropdown-item">Cart</a></router-link>

            </drop-down>

            <drop-down tag="li" position="right" direction="none" class="nav-item btn-rotate dropdown">
                <a slot="title" slot-scope="{ isOpen }" class="nav-link dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" :aria-expanded="isOpen">
                    Orders </a>
                <router-link to="/admin/dashboard/orders"><a class="dropdown-item">Website Orders</a></router-link>
                <router-link to="/admin/dashboard/offlineorders"><a class="dropdown-item">Offline Orders</a></router-link>


            </drop-down>
        </b-navbar-nav>

        <ul class="navbar-nav profile">
            <drop-down icon="nc-icon nc-single-02" tag="li" position="right" direction="none" class="nav-item btn-rotate dropdown">
                <a slot="title" slot-scope="{ isOpen }" class="nav-link dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" :aria-expanded="isOpen">
                    <i class="nc-icon nc-single-02"></i>
                </a>
                <router-link to="/admin/dashboard/profile"><a class="dropdown-item">Profile</a></router-link>
                <router-link to=""><a class="dropdown-item" @click="logout()">Log out</a></router-link>
            </drop-down>
        </ul>

    </template>

</navbar>
</template>

<script>
import {
    Navbar,
} from "src/components/UIComponents";
import Auth from 'src/Auth.js';
import {
    resolveDirective
} from "@vue/runtime-core";

export default {
    components: {
        Navbar,
    },
    data() {
        return {
            activeNotifications: false,
            showNavbar: false,
        };
    },
    methods: {
        goToProfile() {
            this.$router.push({
                name: "User Profile"
            });
        },
        logout() {
            Auth.logout(); //reset local storage
            this.$router.push('/login');
            this.$router.go(0);
            this.flashMessage.success({
                title: 'Logout Succesful',
                message: 'You Have Successfully Logged Out',
            });
            // this.axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/logout`)
            //     .then(({
            //         data
            //     }) => {
            //         // Auth.logout(); //reset local storage
            //         // this.$router.push('/login');
            //         // this.$router.go(0);
            //         // this.flashMessage.success({
            //         //     title: 'Logout Succesful',
            //         //     message: 'You Have Successfully Logged Out',
            //         // });

            //     })
            //     .catch((error) => {
            //         console.log(error);
            //     });
        },
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        toggleNotificationDropDown() {
            this.activeNotifications = !this.activeNotifications;
        },
        closeDropDown() {
            this.activeNotifications = false;
        },
    },
};
</script>

<style>
#docs:hover,
#docs:active,
#docs:focus {
    background-color: #6bd098 !important;
}

#downb:hover,
#downb:active,
#downb:focus {
    background-color: #ef8157 !important;
}

.dashboard {
    background-color: #f4f3ef !important;
    color: #66615B !important;
}

.btn-secondary {
    background-color: #f4f3ef !important;
    color: #66615B !important;
}

.abc {
    position: unset !important;
    width: 100%;
    padding-top: 10px;
    z-index: 999;
}

ul.navbar-nav {
    width: 100%;
}

.profile {
    justify-content: right;
}

a {
    text-decoration: none !important;
}

a:hover {
    color: rgb(27, 41, 228) !important;
}

ul.navbar-nav {
    margin-left: 10px;
}

/* a:visited {
  color: black !important;
} */
</style>
